import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
} from '@mui/material';

const ConfirmDialog = ({
    open,
    onClose,
    onConfirm,
    title = 'Confirm Action',
    message = 'Are you sure? This action cannot be undone.',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    confirmColor = 'secondary',
}) => {
    const handleConfirm = () => {
        onConfirm?.();
        onClose?.();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
        >
            <DialogTitle id="confirm-dialog-title" color="primary">
                {title}
            </DialogTitle>

            <DialogContent>
                <Typography id="confirm-dialog-description" component="div">
                    {message}
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    {cancelText}
                </Button>

                <Button
                    variant="outlined"
                    color={confirmColor}
                    onClick={handleConfirm}
                    autoFocus
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
